import {
  ACCESS_GROUP_FORM_STEPS,
  ACCESS_GROUP_SCHEDULES,
  DEVICE_READERS,
} from '@/config/addAccessGroupFlow';
import type { AccessGroupCreationSuccess, AccessGroupDraft, AccessGroupFormStepId } from '@/types/accessGroupCreation';
import type { GuidedFlowDefinition } from './types';

export const accessGroupCreationFlow: GuidedFlowDefinition<
  AccessGroupDraft,
  AccessGroupFormStepId,
  AccessGroupCreationSuccess
> = {
  id: 'access-group-creation',
  formTitle: 'Create access group',
  systemLabelPrefix: 'System',
  hideStepper: true,
  compactFormCard: true,
  exclusiveSavingScreen: false,
  steps: ACCESS_GROUP_FORM_STEPS,
  schemas: {
    details: {
      id: 'details',
      layout: 'stack',
      fields: [
        {
          id: 'name',
          type: 'text',
          label: 'Name',
          required: true,
          placeholder: 'Enter Access group name',
          aiField: 'name',
        },
        {
          id: 'schedule',
          type: 'select',
          label: 'Schedule',
          required: true,
          aiField: 'schedule',
          options: ACCESS_GROUP_SCHEDULES.map((item) => ({ value: item, label: item })),
        },
        {
          id: 'selectedReaders',
          type: 'list-multi',
          label: 'Select Device readers',
          searchable: true,
          searchPlaceholder: 'Find a reader by name, door, or device...',
          aiField: 'selectedReaders',
          options: [...DEVICE_READERS],
        },
      ],
      backLabel: 'Cancel',
      nextLabel: 'Confirm',
    },
  },
  approvalRows: [
    { key: 'Group name', value: (draft) => draft.name || '—' },
    {
      key: 'Readers',
      value: (draft) =>
        draft.selectedReaders.length > 0
          ? `${draft.selectedReaders.length} selected`
          : '—',
    },
    { key: 'Schedule', value: (draft) => draft.schedule || '—' },
  ],
  success: {
    bannerText: (result) => `${result.groupName} added to this system.`,
    noteText:
      'Added to this system. Users in this group can use these doors when the schedule is active.',
  },
};
